module.exports = __webpack_public_path__ + "img/3.f1f7d9f2.png";